import {getFilteredData ,getSortedData } from '../../../List/helper'
export const getFilteredVehicleClases = ({ vehicleClases, filterKey }) => {
    return getFilteredData({ data: vehicleClases, filterKey })
}
export const getSortedVehicleClasses = ({ vehicleClases, sort }) => {
    return getSortedData({ data: vehicleClases, sort })
  }